import { IProduct } from '@kizi/comparator-core';
import { Div, Image, P } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';
import React from 'react';
import { ProductUsps } from '../../..';
import { Sustainability, sendCustomEvent } from '../../../components';
import { ComparisonSubmitButton } from '../../../components/comparison/ComparisonSubmitButton';
import { AvailabilityIcon } from '../../../components/ProductOverviewModalTriplePlay/AvailabilityIcon';
import { formatPrice } from '../../global';
import { onClick } from '../../product';

const onApplyClick = async (service, data: IProduct) => {
  const index = service.state.context.steps.findIndex(
    (el) => el.id === 'overview',
  );
  const interpreter = service.state.context.steps[index];

  if (data.affiliateUrl || data.affiliateUrl !== '') {
    sendCustomEvent('affiliate-apply', {
      selectedProduct: data,
    });
    const overviewIndex = service._state.context.steps.findIndex(
      (step) => step.id === 'productComparison',
    );
    service.send([
      {
        type: 'GOTO',
        index: overviewIndex,
      },
    ]);

    const url = new URL(window.location.href);
    if (url.searchParams.has('affiliateUrl')) {
      return;
    }
    url.searchParams.set('step', 'overview');

    window.open(`${url.toString()}&affiliateUrl`);
  } else {
    onClick(interpreter, service, data, index + 2);
  }
};

export const getProductComparisonOverview = (data: IProduct, _labels) => {
  const {
    image,
    name,
    priceInfo,
    subscriptionName,
    servicesWrapper,
    testScore,
    purchasableProduct,
  } = data;
  const { initialDiscounted, total } = priceInfo;
  const productSubscriptionName = subscriptionName;
  const priceInfoPerMaand = total || 0;
  const priceInfoPerJaar = initialDiscounted;
  const downloadSpeed =
    servicesWrapper?.networkInformation?.internetSpeed?.downloadSpeedInMb;
  console.log({ data });
  return [
    {
      content: (
        <Div display="flex" flexDirection="column" alignItems="center">
          <Div display="flex" variant="productLogoWrapper" mb={[2, null, 5]}>
            {image ? (
              <>
                <Image
                  alt={`logo-${name}`}
                  height="100%"
                  src={image}
                  width="100%"
                />
              </>
            ) : (
              <Div height={40} />
            )}
          </Div>
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: <Div variant="tabViewTab">{productSubscriptionName}</Div>,
      isVisible: true,
      toggleable: false,
    },
    {
      content: formatPrice(priceInfoPerMaand),
      isVisible: true,
      toggleable: false,
    },
    {
      content: priceInfoPerJaar
        ? formatPrice(priceInfoPerJaar)
        : priceInfoPerJaar,
      isVisible: true,
      toggleable: false,
    },
    {
      content: <ProductUsps data={data.usps} showWarnings={false} />,
      isVisible: true,
      toggleable: false,
    },
    {
      content: <P>{downloadSpeed} Mb/s</P>,
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Sustainability
          score={String(testScore)}
          variant="sustainabilityRegular"
          iconName="favicon"
        />
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: (
        <Div display="flex" justifyContent="center">
          <ComparisonSubmitButton
            data={data}
            fieldName="overview.selectedProduct"
            nextIndex={3}
            onSubmitFn={onApplyClick}
            isProductEnabled={purchasableProduct}
          />
        </Div>
      ),
      isVisible: true,
      toggleable: false,
    },
  ];
};

export const getProductComparisonCosts = (data: IProduct) => {
  const connectionPrice = data.priceInfo.connection || 0;
  const postagePrice = data.priceInfo.postage || 0;

  const getDateLabel = (value: number, period: string) => {
    if (period === 'jaar' || value === 1) {
      return `${value} ${period}`;
    }

    return `${value} ${period}en`;
  };

  return [
    {
      content: formatPrice(connectionPrice),
      isVisible: true,
      toggleable: false,
    },
    {
      content: formatPrice(postagePrice),
      isVisible: true,
      toggleable: false,
    },
    {
      content: getDateLabel(
        Number(data.contractInformation?.deliveryTime.text),
        String(data.contractInformation?.deliveryTime.unit),
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: getDateLabel(
        Number(data.contractInformation?.freeStartDate.period.text),
        String(data.contractInformation?.freeStartDate.period.unit),
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: getDateLabel(
        Number(data.contractInformation?.contractDuration.text),
        String(data.contractInformation?.contractDuration.unit),
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: getDateLabel(
        Number(data.contractInformation?.contractExtension.text),
        String(data.contractInformation?.contractExtension.unit),
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: getDateLabel(
        Number(data.contractInformation?.noticePeriod.text),
        String(data.contractInformation?.noticePeriod.unit),
      ),
      isVisible: true,
      toggleable: false,
    },
  ];
};

export const getProductComparisonInternetPackages = (data: IProduct) => {
  const networkInformation = data.servicesWrapper?.networkInformation;
  const modem = networkInformation?.modems?.modem;

  return [
    {
      content: networkInformation?.internetSpeed?.downloadSpeedInMb ? (
        `${networkInformation?.internetSpeed?.downloadSpeedInMb} Mb/s`
      ) : (
        <IconV2
          variant="optionalBig"
          ml="-10px"
          name={'small-cancel'}
          size="28px"
        />
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: networkInformation?.internetSpeed?.uploadSpeedInMb ? (
        `${networkInformation?.internetSpeed?.uploadSpeedInMb} Mb/s`
      ) : (
        <IconV2
          variant="optionalBig"
          ml="-10px"
          name={'small-cancel'}
          size="28px"
        />
      ),
      isVisible: true,
      toggleable: false,
    },
    {
      content: modem !== undefined ? modem[0].name : null,
      isVisible: true,
      toggleable: false,
    },
    {
      content: networkInformation?.network?.signal?.toUpperCase(),
      isVisible: true,
      toggleable: false,
    },
    {
      content: AvailabilityIcon(networkInformation?.email?.webmail),
      isVisible: true,
      toggleable: false,
    },
    {
      content: networkInformation?.email?.emailBoxes?.numberOfEmailBoxes,
      isVisible: true,
      toggleable: false,
    },
    {
      content: networkInformation?.email?.numberOfAliasesPerBox,
      isVisible: true,
      toggleable: false,
    },
    {
      content: networkInformation?.email?.emailBoxes?.sizeOfEmailBox,
      isVisible: true,
      toggleable: false,
    },
    {
      content: AvailabilityIcon(networkInformation?.email?.spamFilter),
      isVisible: true,
      toggleable: false,
    },
    {
      content: AvailabilityIcon(networkInformation?.email?.virusFilter),
      isVisible: true,
      toggleable: false,
    },
    {
      content: AvailabilityIcon(networkInformation?.homepage),
      isVisible: true,
      toggleable: false,
    },
    {
      content: AvailabilityIcon(networkInformation?.newsgroups),
      isVisible: true,
      toggleable: false,
    },
    {
      content: AvailabilityIcon(networkInformation?.fixedIp),
      isVisible: true,
      toggleable: false,
    },
  ];
};

export const getProductComparisonTelevisionPackages = (data: IProduct) => {
  const televisionInformation = data.servicesWrapper?.televisionInfo;

  return [
    {
      content:
        televisionInformation &&
        televisionInformation.channels.numberOfTvChannels,
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        televisionInformation &&
        televisionInformation.channels.numberOfHdChannels,
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        televisionInformation &&
        televisionInformation.channels.numberOfRadioChannels,
      isVisible: true,
      toggleable: false,
    },
    {
      content: null,
      isVisible: true,
      toggleable: false,
    },
    {
      content: null,
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        televisionInformation && AvailabilityIcon(televisionInformation.guide),
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        televisionInformation &&
        AvailabilityIcon(televisionInformation.recordPrograms),
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        televisionInformation &&
        AvailabilityIcon(televisionInformation.pauseLiveTv),
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        televisionInformation &&
        AvailabilityIcon(televisionInformation.missedPrograms),
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        televisionInformation &&
        televisionInformation.recordPrograms.recordingTimeInHours,
      isVisible: true,
      toggleable: false,
    },
    {
      content: null,
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        televisionInformation &&
        AvailabilityIcon(televisionInformation.videoOnDemand),
      isVisible: true,
      toggleable: false,
    },
  ];
};

export const getProductComparisonCallPackages = (data: IProduct) => {
  const callInformation = data.servicesWrapper?.callInfo;

  const getRateDisplay = (rate: number): string =>
    `€ ${rate.toFixed(2)} per minuut`;

  return [
    {
      content: callInformation && callInformation.rate.startingRate,
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        callInformation &&
        getRateDisplay(callInformation.rate?.rateWithinRegion),
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        callInformation &&
        getRateDisplay(callInformation.rate?.rateOutsideRegion),
      isVisible: true,
      toggleable: false,
    },
    {
      content: callInformation && getRateDisplay(callInformation.rate?.mobile),
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        callInformation && AvailabilityIcon(callInformation.numberPorting),
      isVisible: true,
      toggleable: false,
    },
    {
      content:
        callInformation && AvailabilityIcon(callInformation.callerIdVisibility),
      isVisible: true,
      toggleable: false,
    },
    {
      content: callInformation && AvailabilityIcon(callInformation.voicemail),
      isVisible: true,
      toggleable: false,
    },
  ];
};

export const triplePlayHelpers = {
  overview: getProductComparisonOverview,
  costs: getProductComparisonCosts,
  internetPackages: getProductComparisonInternetPackages,
  televisionPackages: getProductComparisonTelevisionPackages,
  callPackages: getProductComparisonCallPackages,
};
